import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

/**
 * Premium settings card — consistent header/body/footnote structure for every
 * Super Admin settings surface.
 */
export function SettingsCard({
  icon: Icon,
  title,
  subtitle,
  actions,
  children,
  footnote,
  className,
}: {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  footnote?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`overview-panel mt-4 first:mt-0 ${className ?? ""}`}>
      <header className="overview-panel__header">
        <span className="overview-panel__icon" aria-hidden>
          <Icon className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <h3 className="overview-panel__title">{title}</h3>
          {subtitle ? <p className="overview-panel__subtitle">{subtitle}</p> : null}
        </div>
        {actions ? <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div> : null}
      </header>
      <div className="overview-panel__body space-y-4 p-5">{children}</div>
      {footnote ? (
        <div className="border-t border-[var(--border-subtle)] px-5 py-3 text-xs font-semibold text-[var(--text-muted)]">
          {footnote}
        </div>
      ) : null}
    </section>
  );
}
